import { render, staticRenderFns } from "./volume-revert-snapshot.vue?vue&type=template&id=12072573&scoped=true&"
import script from "./volume-revert-snapshot.vue?vue&type=script&lang=js&"
export * from "./volume-revert-snapshot.vue?vue&type=script&lang=js&"
import style0 from "./volume-revert-snapshot.vue?vue&type=style&index=0&id=12072573&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12072573",
  null
  
)

export default component.exports